import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import WebGLWarning from './components/webGLWarning/WebGLWarningComponent';
import SearchTriggerToggle from './components/searchTriggerToggle/SearchTriggerToggleComponent';
import 'mapbox-gl/dist/mapbox-gl.css';

function MapComponent({
  children,
  webGLEnabled,
  showSearchTriggerToggle,
  styles,
  mapWasMoved,
  onlyHotelsOnMap,
  onClickRedoSearchHere,
  onClickOnlyHotelsOnMapCheckbox,
}) {
  return (
    <Root styles={styles}>
      {webGLEnabled ? (
        <Fragment>
          {children}
          {showSearchTriggerToggle && (
            <SearchTriggerToggle
              mapWasMoved={mapWasMoved}
              onlyHotelsOnMap={onlyHotelsOnMap}
              onClickRedoSearchHere={onClickRedoSearchHere}
              onClickOnlyHotelsOnMapCheckbox={onClickOnlyHotelsOnMapCheckbox}
            />
          )}
        </Fragment>
      ) : (
        <WebGLWarning />
      )}
    </Root>
  );
}

export default MapComponent;

const Root = styled.div`
  position: relative;

  ${({ styles }) =>
    styles &&
    css`
      ${styles}
    `}
`;
